import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCreateFolder } from './tracking';
import { FoldersListItemNew } from '../../../components/FoldersList/FoldersListItem/FoldersListItemNew';
import { ModalCreateFolder } from '../../../components/FoldersList/create';
import { selectResults } from '../../../selectors';
import { selectUser } from '../../../selectors/user';
import { createFolder } from '../../../thunk/favorites';

export function CreateFolderContainer() {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const { favoriteEntities } = useSelector(selectResults);
  const [isModalOpened, setIsModalOpened] = React.useState(false);

  const handleConfirm = (name: string) => {
    setIsModalOpened(false);
    dispatch(createFolder(name));
    trackCreateFolder(favoriteEntities);
  };

  const handleClick = () => {
    if (user.isAuthenticated) {
      setIsModalOpened(true);
    } else {
      window.waitForLoginPopup();
    }
  };

  return (
    <>
      <ModalCreateFolder isVisible={isModalOpened} onConfirm={handleConfirm} onCancel={() => setIsModalOpened(false)} />
      <FoldersListItemNew onClick={handleClick} />
    </>
  );
}
